import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Spinner } from 'react-bootstrap';
import { Button } from '../../../../components/ui/Button';
import { Dialog } from 'primereact/dialog'

import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { useCreateFolderMutation } from '../../../../queries/folderMedia';

function CreateFolderPopup({ setCurrentFolder, setBreadCrumb, breadCrumb }) {
    const { t } = useTranslation();
    const { formState: { errors }, handleSubmit, register, reset } = useForm({ name: "" });
    const { mutate: createFolder, isLoading } = useCreateFolderMutation(setCurrentFolder, setBreadCrumb, breadCrumb);

    const { openDialog } = useSelector((state) => state.global);
    const dispatch = useDispatch();
    const { id } = useParams();

    const onSubmit = (data) => {
        data.parent_folder_id = id;
        createFolder({ data, parentFolderId: id });
        reset();
    };

    return (
        <>
            <Button
                icon={<i className="bx bx-folder-plus fs-4 mt-1 me-1 mb-2"></i>}
                label={t('media.media_new_folder')}
                tooltipOptions={{ position: 'bottom', autoHide: false }}
                onClick={() => dispatch(toggleDialog("createFolder"))}
                className="text-secondary font-normal bg-transparent border-0 p-0  mx-3" />

            <Dialog header={t('media.media_folder_creation')}
                visible={openDialog.createFolder}
                onHide={() => { dispatch(toggleDialog("createFolder")) }}
                breakpoints={{ '960px': '95vw' }}
                style={{ width: '30vw' }}>

                <form onSubmit={handleSubmit(onSubmit)} >
                    <div className="my-5 px-5">
                        <input
                            {...register("name", {
                                required: t('media.media_folder_name_required'),
                                minLength: {
                                    value: 3, message: t('media.media_folder_name_min_length'),
                                },
                                pattern: {
                                    value: /^[^.].*$/,
                                    message: t('media.media_folder_name_invalid'),
                                },
                            })}
                            aria-invalid={errors.name ? "true" : "false"}
                            className={errors.name ? 'form-control is-invalid' : 'form-control'}
                            placeholder={t('media.media_folder_name_placeholder')} id='folder_name'
                        />
                        {errors.name && <p className='fv-plugins-message-container invalid-feedback'>{errors.name?.message}</p>}
                    </div>
                    <div className="col-12 text-center d-flex  align-items-end  justify-content-center py-4 border-top border-gray">
                        <button type="reset" className="btn btn-label-secondary me-3" data-bs-dismiss="modal" aria-label="Close" disabled={isLoading} onClick={() => dispatch(toggleDialog("createFolder"))}>{t('buttons.cancel')}</button>
                        <button type="submit" className="btn btn-primary" disabled={isLoading} >
                            {
                                isLoading ?
                                    <Spinner variant="white" as="span" animation="border" size="sm" role="status" className='mx-3' aria-hidden="true" />
                                    :
                                    t('buttons.create')
                            }
                        </button>
                    </div>
                </form>

            </Dialog>
        </>
    )
}

export default CreateFolderPopup